import { AuthConfig } from 'angular-oauth2-oidc';
import { environment } from 'src/environments/environment';

export const authConfig: AuthConfig = {
  loginUrl: environment.apiDomain + '/identity/oauth2/authorize',
  logoutUrl: environment.apiDomain + '/identity/oauth2/revoke',
  tokenEndpoint: environment.apiDomain + '/identity/oauth2/token',
  redirectUri: window.location.origin + '/ergo/auth/login',
  clientId: environment.oauthClientId,
  responseType: 'code',
  scope: 'openid',
  requireHttps: true,
  strictDiscoveryDocumentValidation: false,
  oidc: true,
  skipIssuerCheck: true,
  clearHashAfterLogin: false,
};
